import { DocumentReference, Timestamp } from "firebase/firestore";

// User interface for /users/{uid} documents in Firebase
// Note: firstName/lastName are stored in UserPermission (org-scoped), not here
// Note: membershipState has been removed — access state is derived from org subcollections
export interface User {
  id: string;
  email: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

// Normalized role names (lowercase, no spaces)
// This is the single source of truth for valid roles in the application
export const ORGANIZATION_ROLES = ["viewer", "collector", "editor", "admin"] as const;
export type OrganizationRole = (typeof ORGANIZATION_ROLES)[number];

// Normalized status
export type Status = "active" | "disabled";

// UserPermission represents /organizations/{orgId}/userPermissions/{uid} documents
// Contains org-scoped user profile data and role/status
export interface UserPermission {
  id: string;
  userRef: DocumentReference;
  role: OrganizationRole;
  status: Status;

  // User profile data (org-scoped, denormalized)
  email: string;
  firstName: string;
  lastName: string;

  // Terms of Service acceptance tracking
  tosAcceptedVersion?: string; // e.g., "standardDataSharing-v1.0"
  tosAcceptedAt?: Timestamp;

  createdAt: Timestamp;
  updatedAt: Timestamp;
  createdBy: DocumentReference;
  updatedBy: DocumentReference;
}
